module.exports = __webpack_public_path__ + "static/media/clay-correct.f8e9ff86.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueBridge/clay-correct.png
// module id = 3523
// module chunks = 0